import script from "./AppSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSearch.vue?vue&type=script&setup=true&lang=js"

import "./AppSearch.vue?vue&type=style&index=0&id=9c4b5dbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c4b5dbe"]])

export default __exports__